import { render } from "./CardEntitas.vue?vue&type=template&id=15310d4d"
import script from "./CardEntitas.vue?vue&type=script&lang=js"
export * from "./CardEntitas.vue?vue&type=script&lang=js"

import "./CardEntitas.vue?vue&type=style&index=0&id=15310d4d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__